import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import useFormGenerator from '../common/FormUtils';
import useHeaderGenerator from '../common/functions/useHeaderGenerator';
import useButtonsGenerator from '../common/functions/useButtonsGenerator';
import { useParams } from 'react-router-dom';
import FormModal from '../common/FormModal';
import FeedbackService from './FeedbackService';

import schema from './feedbackRequestSchema.js';
import DirectoryService from '../directory/DirectoryService';
const jsonSchema = schema;
const mergedJsonSchema = (jsonSchema, users) => {
  const reviewerList = users;
  return jsonSchema.map(field => {
    if (field.name === 'employee') {
      return {
        ...field,
        options: reviewerList
      };
    }
    if (field.name === 'reviewer') {
      console.log(field.name);
      return {
        ...field,
        options: reviewerList
      };
    }
    return field;
  });
};

const FeedbackRequestForm = () => {
  const { identifier } = useParams();
  const [data, setData] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [users, setUsers] = useState([]);
  useEffect(() => {
    setData(undefined === identifier ? {} : null);
    const fetchData = async () => {
      const usersByAccount = await DirectoryService.retrieveUsersByAccount();
      const mappedUsers = usersByAccount.map(u => ({
        value: u.identifier,
        label: u.firstName + ' ' + u.lastName
      }));
      setUsers(mappedUsers);
    };
    fetchData();
  }, []);

  const handleFeedbackRequestFormSubmit = formData => {
    FeedbackService.requestFeedback(formData)
      .then(response => {
        console.log(response);
        setModalShow(true);
      })
      .catch(error => console.log(error));
  };

  const buttonsConf = [
    {
      name: 'Send Feedback Request',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Semd Feedback Request');
      }
    },
    {
      name: 'Cancel',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Semd Feedback Request');
      }
    }
  ];
  const headerGenerated = useHeaderGenerator('Request a Feedback', ' ', []);

  return (
    <>
      {headerGenerated}
      {modalShow && (
        <FormModal
          message={'Feedback request has been sent!'}
          modalShow={modalShow}
          setModalShow={setModalShow}
        />
      )}
      <Card>
        <Card.Body>
          {data || undefined === identifier ? (
            // Pass data to the form generator hook
            <FormGeneratorWithData
              data={data}
              buttonsConf={buttonsConf}
              onSubmit={handleFeedbackRequestFormSubmit}
              users={users}
            />
          ) : (
            <p>Loading...</p>
          )}
        </Card.Body>
      </Card>
    </>
  );
};
const FormGeneratorWithData = ({ data, buttonsConf, onSubmit, users }) => {
  const [validated, setValidated] = useState(false);
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  // Use the useFormGenerator hook with the provided data
  const { formFields, handleSubmit } = useFormGenerator(
    mergedJsonSchema(jsonSchema, users),
    onSubmit,
    data,
    setValidated
  );

  // Render your form using the formFields and event handlers
  return (
    <Form
      className="mb-2"
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
    >
      {formFields}
      <Card.Footer>{buttonsGenerated}</Card.Footer>
    </Form>
  );
};

FormGeneratorWithData.propTypes = {
  buttonsConf: PropTypes.any,
  data: PropTypes.any,
  onSubmit: PropTypes.any,
  users: PropTypes.any
};
export default FeedbackRequestForm;
